import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    // we init with resources
    resources: {
        en: {
            translations: {
                Checkout: 'Checkout',
                Address: 'Address',
                Payment: 'Payment',
                'Review Order': 'Review Order',
                'Only x left': 'Only {{Inventory}} left!',
                'Order Summary': 'Order Summary',
                'Modified Order Summary': 'Modified Order Summary',
                Subtotal: 'Subtotal',
                Shipping: 'Shipping',
                Free: 'Free',
                'Est Taxes': 'Est Taxes',
                'Applied Discounts': 'Applied Discounts',
                Discount: 'Discount',
                'Gift Card Redeemed': 'Gift Card Redeemed',
                'TOTAL PRICE': 'TOTAL PRICE',
                'NEW TOTAL PRICE': 'NEW TOTAL PRICE',
                'Original Order Total': 'Original Order Total',
                'Change to Order Total': 'Change to Order Total',
                'You are saving': 'You’re saving {{savings}} on this order!',
                QTY: 'QTY',
                'Monthly payments with easy pay': 'Monthly payments with easy pay®',
                'Number of Installments': 'Number of Installments',
                'Your Total Payment Today': 'Your Total Payment Today',
                'Payment Amount Left After Today': 'Payment Amount Left After Today',
                'Future Monthly Payments': 'Future Monthly Payments',
                'Enter Promo Code': 'Enter Promo Code',
                Apply: 'Apply',
                'Enter Gift Card': 'Enter Gift Card',
                'Place Order': 'Place Order',
                'Items are not reserved until orders are placed': 'Items are not reserved until order is placed',
                'Payment Option': 'Payment Option',
                'Payment Method': 'Payment Method',
                'Payment Method Missing': 'Please enter a payment method',
                'Taxes & Shipping excluded': 'Taxes & Shipping excluded',
                'Billing Address': 'Billing Address',
                'Same as shipping address': 'Same as shipping address',
                'Applied to eligible items': 'Applied to eligible items',
                'Employee agreement': 'By placing your order, you agree and understand ',
                'Employee Purchase Policy': 'TSC’s Employee Purchase Policy',
                'Shipping Method': 'Shipping Method',
                'Shipping Address': 'Shipping Address',
                'Review your order': 'Review your order',
                'Terms of Use': 'Terms of Use',
                'Privacy Policy': 'Privacy Policy',
                'Shipping Conditions': 'Shipping Conditions',
                'Change Shipping Address': 'Change Shipping Address',
                'Change Billing Address': 'Change Billing Address',
                'Change Shipping Method': 'Change Shipping Method',
                'Add Shipping Address': 'Add Shipping Address',
                Change: 'Change',
                CANCEL: 'CANCEL',
                'Add Change': 'Add/Change',
                Add: 'Add',
                Close: 'Close',
                'Merged Items Note': 'Shopping Bag contains previously added items',
                'Employee Agreement Authorization': 'Agreement & Authorization',
                'Employee Agreement Statement':
                    'I certify that this order will be charged to my own credit card. I’ve also read, understood and agreed to TSC’s Employee Purchase Policy.',
                'Yes Agree': 'YES, I AGREE',
                'Make a Change': 'Make A Change',
                'Pay with your Rogers Bank MasterCard and get': 'Pay with your Rogers Bank MasterCard and get',
                'Card Expired': 'Card has expired',
                'Use A New Card': 'Use A New Card',
                'Edit Credit Card': 'Edit Payment Card',
                'Remove Credit Card': 'Remove Payment Card',
                'Remove Card': 'Yes, Remove This Card',
                'Do not Remove Card': 'No, Don’t Remove This Card',
                'Remove Card Text': 'Please confirm you want to remove this payment card.',
                'Free Shipping': 'Free Shipping',
                'Select Card Type': 'Select Card Type',
                'Items in Order': 'Items in Order ({{order}})',
                'Items Being Added': 'Items Being Added ({{order}})',
                'Existing Items': 'Existing Items ({{orderedItems}})',
                'One Payment of': 'One Payment of {{orderTotal}}',
                'Only one promo code can be entered at a time.': 'Only one promo code can be entered at a time.',
                PIN: 'PIN',
                Remove: 'Remove',
                'Account Credit': 'Account Credit',
                'Enter Account Credit': 'Enter Account Credit',
                'Remaining Credits': 'Credits remaining after purchase',
                'Initial Credits': 'Credits available',
                'ending in': 'ending in ',
                'Expires on': 'Expires on ',
                'Required fields are marked with an asterik': 'Required fields are marked with an asterik',
                'First Name': 'First Name',
                'Last Name': 'Last Name',
                'Phone number': 'Phone number',
                'Address Line 2': 'Address Line 2',
                'e.g. Apartment, Suite, Unit, Building Floor': 'e.g. Apartment, Suite, Unit, Building Floor',
                City: 'City',
                Province: 'Province',
                'Postal code': 'Postal code',
                Email: 'Email',
                "Sign me up for Special Offers & Today's Showstopper Emails. I understand that I may withdraw my consent at any time.":
                    "Sign me up for Special Offers & Today's Showstopper Emails. I understand that I may withdraw my consent at any time.",
                'Create a TSC account and enjoy faster checkout, editing your order, purchase history, special rewards and more.':
                    'Create a TSC account and enjoy faster checkout, editing your order, purchase history, special rewards and more.',
                'Continue To Payment': 'Continue To Payment',
                'Continue To Review': 'Continue To Review',
                'Credit Card': 'Credit Card',
                Password: 'Password',
                'Retype Password': 'Retype Password',
                Show: 'Show',
                Hide: 'Hide',
                'Card Number': 'Card Number',
                'Expiration Date': 'Expiration Date',
                YY: 'YY',
                Select: 'Select',
                Selected: 'Selected',
                Edit: 'Edit',
                'Add New Address': 'Add New Address',
                'Save & Continue': 'Save & Continue',
                Back: 'Back',
                'Edit Shipping Address': 'Edit Shipping Address',
                'CHANGE PAYMENT METHOD': 'CHANGE PAYMENT METHOD',
                'You have one or more missing or invalid entries. Please enter correct data and try again.':
                    'You have one or more missing or invalid entries. Please enter correct data and try again.',
                'First name is required.': 'First name is required.',
                'Last name is required.': 'Last name is required.',
                'Phone number is required.': 'Phone number is required.',
                'Address is required.': 'Address is required.',
                'City is required.': 'City is required.',
                'Postal code is required.': 'Postal code is required.',
                'Password is required.': 'Password is required.',
                'Valid email is required.': 'Valid email is required.',
                'Password must have minimum of 6 alphanumeric characters with at least one number':
                    'Password must have minimum of 6 alphanumeric characters with at least one number',
                'must match password': 'Pas' + "swords don't match",
                'Numbers and special characters are not allowed.': 'Numbers and special characters are not allowed.',
                'Please provide a valid phone number': 'Please provide a valid phone number',
                'Please enter a valid credit card number.':
                    'The credit card number entered is not valid.  Please try again.',
                'Please enter valid expiration date.': 'Please enter valid expiration month.',
                'Please click or tap on the PayPal button to proceed.':
                    'Please click or tap on the PayPal button to proceed.',
                'Learn More': 'Learn More',
                'TSC employees are not entitled to redeem promotional savings cards.':
                    'TSC employees are not entitled to redeem promotional savings cards.',
                'We are unable to verify your credit card because of an invalid CVV number. Please try again.':
                    'We are unable to verify your credit card because of an invalid CVV number. Please try again.',
                AutoDeliveryMessage: 'This item will be delivered ',
                AutoDeliveryMessageEvery: 'every ',
                'Langue - English': 'Language - English',
            },
        },
        fr: {
            translations: {
                Checkout: 'Validation',
                Address: 'ADRESSE',
                Payment: 'PAIEMENT',
                'Review Order': 'CONFIRMATION',
                'Only x left': 'Il n’en reste que {{Inventory}}!',
                'Order Summary': 'SOMMAIRE DE LA COMMANDE',
                'Modified Order Summary': 'LA COMMANDE MODIFIER',
                Subtotal: 'Sous-total',
                Shipping: 'Livraison',
                Free: 'Free',
                'Est Taxes': 'Taxes prévues',
                'Applied Discounts': 'Rabais appliqués',
                Discount: 'Réductions',
                'Gift Card Redeemed': 'Carte-cadeau échangée',
                'TOTAL PRICE': 'PRIX TOTAL',
                'NEW TOTAL PRICE': 'Nouveau Prix Total',
                'Original Order Total': 'Total de L’ordre Initial',
                'Change to Order Total': 'Modification du total',
                'You are saving': 'Vous économisez {{savings}} sur cette commande!',
                QTY: 'QTY',
                'Monthly payments with easy pay': 'Versements mensuels paiement pratiqueᴹᴰ',
                'Number of Installments': 'Nombre de paiements',
                'Your Total Payment Today': 'Votre total aujourd’hui',
                'Payment Amount Left After Today': 'Solde restant dû',
                'Future Monthly Payments': 'Paiement(s) Mensuel(s) Futur(s) de:',
                'Enter Promo Code': 'ENTRER UN CODE',
                Apply: 'Appliquer',
                'Enter Gift Card': 'Entrer le numéro de la carte-cadeau',
                'Place Order': 'PASSER MA COMMANDE',
                'Items are not reserved until orders are placed':
                    'Les articles ne sont pas réservés tant que la commande n’a pas été passée',
                'Payment Option': 'OPTION DE PAIEMENT',
                'Payment Method': 'MODE DE PAIEMENT',
                'Payment Method Missing': 'Please enter a payment method',
                'Taxes & Shipping excluded': 'Taxes et frais d’expédition non compris',
                'Billing Address': 'ADRESSE DE FACTURATION',
                'Same as shipping address': 'L’adresse de livraison est la même que pour la facturation',
                'Applied to eligible items': "S'applique aux articles admissibles",
                'Shipping Method': 'MODE D’EXPÉDITION',
                'Shipping Address': 'ADRESSE DE LIVRAISON',
                'Review your order': 'Review your order',
                'Terms of Use': 'Modalités d’utilisation',
                'Privacy Policy': 'Politique de confidentialité',
                'Shipping Conditions': 'Conditions d’expédition',
                'Change Shipping Address': "CHANGER L'ADRESSE DE LIVRAISON",
                'Change Billing Address': 'Change Billing Address',
                'Change Shipping Method': "MODIFIER LE MODE D'EXPÉDITION",
                'Add Shipping Address': "AJOUTER L'ADRESSE DE LIVRAISON",
                Change: 'CHANGER',
                CANCEL: 'Annuler',
                'Add Change': 'AJOUTER/CHANGER',
                Add: 'AJOUTER',
                Close: 'Fermer',
                'Merged Items Note': 'Votre panier contient des articles ajoutés antérieurement',
                'Employee Agreement Authorization': 'Agreement & Authorization',
                'Employee Agreement Statement':
                    'I certify that this order will be charged to my own credit card. I’ve also read, understood and agreed to TSC’s Employee Purchase Policy.',
                'Yes Agree': 'YES, I AGREE',
                'Make a Change': 'Make A Change',
                'Pay with your Rogers Bank MasterCard and get': 'Pay with your Rogers Bank MasterCard and get',
                'Card Expired': 'Card has expired',
                'Use A New Card': 'UTILISER UNE NOUVELLE CARTE',
                'Edit Credit Card': 'Edit Payment Card',
                'Remove Credit Card': 'Remove Payment Card',
                'Remove Card': 'Yes, Remove This Card',
                'Do not Remove Card': 'No, Don’t Remove This Card',
                'Remove Card Text': 'Please confirm you want to remove this payment card.',
                'Free Shipping': 'Livraison gratuite',
                'Select Card Type': 'TYPE DE CARTE (Sélectionner)',
                'Items in Order': 'ARTICLES EN COMMANDE ({{order}})',
                'Items Being Added': 'Éléments en cours d’ajout ({{order}})',
                'Existing Items': 'Articles Existants ({{orderedItems}})',
                'One Payment of': 'Un versement de {{orderTotal}}',
                'Only one promo code can be entered at a time.': 'Un seul code promotionnel peut être entré à la fois.',
                PIN: 'NIP',
                Remove: 'Supprimer',
                'Account Credit': 'Account Credit',
                'Enter Account Credit': 'Enter Account Credit',
                'Remaining Credits': 'Credits remaining after purchase',
                'Initial Credits': 'Credits available',
                'ending in': 'se terminant par ',
                'Expires on': 'Date d’expiration ',
                'Required fields are marked with an asterik': 'Champs obligatoires sont indiqués par un astérisque',
                'First Name': 'PRÉNOM',
                'Last Name': 'NOM DE FAMILLE',
                'Phone number': 'NUMÉRO DE TÉLÉPHONE',
                'Address Line 2': 'COMPLÉMENT D’ADRESSE',
                'e.g. Apartment, Suite, Unit, Building Floor': 'App., bât., autre',
                City: 'VILLE',
                Province: 'PROVINCE',
                'Postal code': 'Code Postal',
                Email: 'ADRESSE COURRIEL',
                "Sign me up for Special Offers & Today's Showstopper Emails. I understand that I may withdraw my consent at any time.":
                    "Inscrivez-moi aux offres spéciales et aux courriels Today's Showstopper.  Je comprends que je peux retirer mon consentement en tout temps.",
                'Create a TSC account and enjoy faster checkout, editing your order, purchase history, special rewards and more.':
                    "Créez un compte TSC et profitez d'un paiement plus rapide, de la modification de votre commande, de l'historique des achats, des récompenses spéciales et plus encore.",
                'Continue To Payment': 'CONTINUER À PAYER',
                'Continue To Review': "CONTINUER D'EXAMINER",
                'Credit Card': 'CARTE DE CRÉDIT',
                'TSC Credit Card': 'CARTE DE CRÉDIT TSC',
                Password: 'MOT DE PASS',
                'Retype Password': 'RETAPER LE MOT DE PASSE',
                Show: 'AFFICHER',
                Hide: 'MASQUER',
                'Card Number': 'NUMÉRO DE CARTE',
                'Expiration Date': 'DATE D’EXPIRATION',
                YY: 'AA',
                Select: 'Sélectionner',
                Selected: 'Sélectionné',
                Edit: 'Modifier',
                'Add New Address': 'AJOUTER NOUVELLE ADRESSE',
                'Save & Continue': 'ENREGISTRER ET CONTINUER',
                Back: 'Retourner',
                'Edit Shipping Address': 'MODIFIER L’ADRESSE DE LIVRAISON',
                'Change Payment Method': 'MODIFIER LE MODE DE PAIEMENT',
                'You have one or more missing or invalid entries. Please enter correct data and try again.':
                    'Il y a une ou plusieurs entrées manquantes ou invalides. Veuillez entrer les données correctes et réessayer.',
                'First name is required.': 'Veuillez entrer votre prénom',
                'Last name is required.': 'Veuillez entrer votre nom de famille.',
                'Phone number is required.': 'Veillez entrer votre numéro de téléphone.',
                'Address is required.': 'Veuillez entrer votre adresse.',
                'City is required.': 'Veuillez entrer la ville.',
                'Postal code is required.': 'Veuillez entrer votre code postal.',
                'Password is required.': 'Veuillez entrer un mot de passe.',
                'Valid email is required.': 'Veuillez entrer un e-mail valide.',
                'Password must have minimum of 6 alphanumeric characters with at least one number':
                    'Le mot de passe doit avoir un minimum de 6 caractères alphanumériques avec au moins un chiffre',
                'must match password': 'Les mots de pas' + 'se ne correspondent pa' + 's.',
                'Numbers and special characters are not allowed.':
                    'Les chiffres et les caractères spéciaux ne sont pas autorisés.',
                'Please provide a valid phone number': 'Veuillez fournir un numéro de téléphone valide',
                'Please enter a valid credit card number.':
                    'Veuillez entrer un numéro de carte de crédit valide et réessayer',
                'Please enter valid expiration date.': "Veuillez entrer une date d'expiration valide",
                'Please click or tap on the PayPal button to proceed.':
                    'Veuillez cliquer sur le bouton PayPal pour continuer.',
                'Learn More': 'En savoir plus',
                'TSC employees are not entitled to redeem promotional savings cards.':
                    "Les employés de TSC n'ont pas le droit d'échanger des cartes d'économies promotionnelles.",
                'We are unable to verify your credit card because of an invalid CVV number. Please try again.':
                    "Nous ne sommes pas en mesure de vérifier votre carte de crédit en raison d'un numéro CVV invalide.Veuillez réessayer.",
                AutoDeliveryMessage: 'Cet article sera livré ',
                AutoDeliveryMessageEvery: 'tous les ',
                'Langue - English': 'Langue - English',
            },
        },
    },
    fallbackLng: 'en',
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false, // we use content as keys
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
